import { render, staticRenderFns } from "./TableAlert.vue?vue&type=template&id=252042be&scoped=true&"
import script from "./TableAlert.vue?vue&type=script&lang=js&"
export * from "./TableAlert.vue?vue&type=script&lang=js&"
import style0 from "./TableAlert.vue?vue&type=style&index=0&id=252042be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252042be",
  null
  
)

export default component.exports